<template>
  <main class="page-horseman-platforms page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增里程碑</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="所属品牌:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width:110px;"
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >查无该品牌，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="218" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)">编辑</el-button>

            <el-button class="delete__btn" @click="$_updateStatus(scope.row, 3)">删除</el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row" :tag="column.key"></component>
          </template>
        </el-table-column>
        <el-table-column></el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getOrderCompanys"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import modalModify from "./modal-modify";

const columns = [
  { key: "brandName", label: "所属品牌", width: 120 },
  { key: "title", label: "标题", width: 120 },
  { key: "time", label: "里程碑时间", width: 120 },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160}
];
export default {
  name: "portal-milestone",
  mixins: [resize],
  data() {
    return {
      isLoading: false,
      filter: {
        brandName: "",
        brandId:0,
      },
      searchBrandData: [],
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        type: "add",
        template: "",
        data: {}
      }
    };
  },
  watch: {
    brandName(val) {
      if (!val) this.filter.brandId = 0;
    }
  },
  computed: {
    brandName() {
      return this.filter.brandName;
    }
  },
  methods: {
        // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999
      };
      this.$service.post("getBrandList", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = 0;
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getOrderCompanys();
    },
    // 重置
    $_reset() {
      this.filter.brandName = "";
       this.filter.brandId = 0;
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getOrderCompanys();
    },
    // 查询接口列表
    $_getOrderCompanys() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        brandId: this.filter.brandId,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("milestonepaging", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 新增/编辑账号成功回调
    $_callback() {
      this.$_close();
      this.$_getOrderCompanys();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 新增/编辑
    $_modify($index, row) {
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增里程碑";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.data = JSON.parse(JSON.stringify(row));
        this.modal.title = "编辑里程碑";
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },

    // 更新品牌状态 - 1-启用/2-停用/3-删除
    $_updateStatus(row, status) {
      const self = this;
      let content = `是否${
        status === 1 ? "启用" : status === 2 ? "停用" : "删除"
      }当前选项?`;
      let mid = [row.mid];
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("milestonedelete", {
              mid,
              status: status
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getOrderCompanys();
                  }
                });
              }
            });
        }
      });
    },

    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getOrderCompanys();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getOrderCompanys();
    }
  },

  components: {
    modalModify,
  },

 async mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getOrderCompanys();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
  // margin-bottom: 44px;
}
</style>
